import { getDeviceLabel } from 'utils/user-agent';
import { getDeviceId } from './device-id';

export { getDeviceId, getStoredDeviceId } from './device-id';

export const DEVICE_PLATFORM = 'web';

/**
 * Whether the tenant has the device limit extension. The web config lists an extension under `extensions` only
 * when it is enabled; without it the app sends no device params and makes no device calls.
 */
export const isDeviceLimitEnabled = (config) => Boolean(config?.extensions?.device_limit);

/**
 * The device params the auth host expects on `auth_webauth_url`, for tenants with the device limit extension.
 * `app_build` is mobile only.
 */
export const getDeviceAuthParams = async () => ({
  device_id: (await getDeviceId()) ?? '',
  device_platform: DEVICE_PLATFORM,
  device_label: getDeviceLabel(),
});

export const addDeviceAuthParams = (authUrl, params) => {
  const url = new URL(authUrl);

  Object.entries(params).forEach(([name, value]) => url.searchParams.set(name, value));

  return url.toString();
};
